import { render, staticRenderFns } from "./book-notes.vue?vue&type=template&id=67f2bf5a&scoped=true"
import script from "./book-notes.vue?vue&type=script&lang=js"
export * from "./book-notes.vue?vue&type=script&lang=js"
import style0 from "./book-notes.vue?vue&type=style&index=0&id=67f2bf5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f2bf5a",
  null
  
)

export default component.exports